<template>
    <el-container @click.stop @contextmenu="rightClick"  id="xx01" style="height: 100%">
        <el-main style="padding:0">
            <div :id="id" :option="option" style="display: none;"></div>
            <div v-if="isReloadData">
                <div class="main_div" style="height: calc(100vh - 67px - 50px - 8px - 54px)">
                  <div class="chart-content" v-for="(item, i) in chartOptions" :key="i">
                    <div :id="'chart_'+i" :style="item.chartContentStyle"></div>
  <!--                  <div class="affix-container float_div">-->
                  </div>
                  <div class="float_div">
                    <el-collapse-transition class="option">
                      <div id="ChartOption" v-show="showChartOption" :style="getOptionDivWidthStyle()" >
<!--                      <div id="ChartOption" v-show="showChartOption">-->
                        <ChartOptions  style=" width: 250px" :selectObjOption="selectedChartOption" :selectObjInfo="selectObjInfo"
                                       @reflashView-event="_changeChartStyle" @changeSyncScale="_changeSyncScale" @changexAisxTick="_changexAisxTick"/>
                      </div>
                    </el-collapse-transition>
                  </div>
                </div>
            </div>
        </el-main>
<!--        <div style="margin-top: 5px; " class="div-opacity">-->
<!--          <el-collapse-transition style="opacity:0.6;" class="div-opacity">-->
<!--            <div  v-show="showChartOption" style=" width: 250px;  opacity:0.6; " class="div-opacity">-->

<!--              <ChartOptions  style=" width: 250px; opacity:0.6; " :selectObjOption="selectedChartOption" :selectObjInfo="selectObjInfo"/>-->
<!--            </div>-->
<!--          </el-collapse-transition>-->
<!--        </div>-->
      <!--<ChartOptions   style=" width: 250px; opacity:0.6; " :selectObjOption="selectedChartOption" :selectObjInfo="selectObjInfo"/>-->
        <div class="affix-container">
          <el-affix target=".affix-container" :offset="80">
            <el-button id="cx" :disabled="chartOptions.length == 0" type="primary" icon="el-icon-setting" size="mini" circle style="height:28px" @click="chartOptionIsShow"/>
          </el-affix>
        </div>

        <!--<contextmenu>1111111111111</contextmenu>-->
    </el-container>
</template>
<script>
  import ChartOptions from './ChartOptions.vue'
  import HighCharts from 'highcharts'
  import axios from 'axios';
  import eventbus from '../event.js'
  import { ElMessage } from 'element-plus'
  import exporting from "highcharts/modules/exporting"
 // import contextmenu from'./contextmenu.vue'
  exporting(HighCharts);
  export default {
    components: {
      ChartOptions,
      //contextmenu
    },
    // 验证类型
    props: {
      id: {
        type: String
      },
      option:{
        type: Object
      },
      chartType: {
        type: String //normal、wellgroup
      },
      isHomePage:{
        type: String
      }
    },
    watch: {
      option: {
        type: Object,
        handler: function (oldVal,newVal) {
          if(oldVal != newVal) {
            //默认设置图表高度
            this.option.forEach(item => {
              // console.log("abccccc",this.chartContentStyle,item.chartContentStyle)
              if (item.chartContentStyle == undefined)
                item.chartContentStyle = JSON.parse(JSON.stringify(this.chartContentStyle));

              if (item.chartContentStyle != undefined){
                item.chartContentStyle["margin-bottom"] = "1px"
              }
              console.log("abcccc",item.chartContentStyle)

              if (item.autoChartStyle == undefined)
                item.autoChartStyle = true;//自动计算高度标识（默认自动计算）
              if (item.xAxis.labels.enabled == undefined)
                item.xAxis.labels.enabled = true;//默认设置x轴的值显示为true
              if (item.syncScale==undefined || item.syncScale==null)
                item.syncScale=false;//同步缩放标识，默认不同步

            });
            //计算图表高度
            this._changeChartStyle(this.option[0].autoChartStyle);
            // this._changeChartYAxis();
            // console.log(this._changeChartStyle(this.option[0].autoChartStyle))
            // console.log("切换数据————————————————————");
            // console.log(document.documentElement.clientHeight)
            // console.log(document.body.clientHeight,this.chartStyle,this.chartHeightAry)
            // console.log(this.option.index)
            let  chartHeight = 0;
            this.chartHeightAry.forEach(item=>{
              chartHeight += parseFloat(item)
              chartHeight += 50
            })
            // console.log("chartHeight:",chartHeight);
            this.$store.state.busVueHeight[this.option.index] = chartHeight;
            // console.log("charts:",this.charts);
          }
        },
      },

    },
    data: function () {
      return {
        value: '',
        visible: false,
        headerDefHeight:56,//默认头高-导航、菜单、banner合高
        chartMinHeight:150,//最小单chart高度
        chartTitleHeight:30,//单chart标题高度
        chartStyle:"height: 150px",//margin-bottom: 50px //默认单chart高度
        chartHeightAry:[],//margin-bottom: 50px //多chart高度样式列表
        charts: [],//所有创建的图表对象
        chartOptions: this.option,//所有对象对应配置
        //selectObjType: "chart",//选择对象类型：chart, series, point
        selectObjInfo: {},//选择对象参数
        selectedChartOption: this.option.length > 0 ? this.option[0] : {},//选中对象对应配置
        selectedChartIndex: 0,//选中对象对应序号(记录选中 坐标绘图的序号)
        chartEvent: {
          events: {
            click: (e) => {
              this.chartClick(e)
            },
            //图表区域被选中时触发
            selection: (e) => {
              // console.log("ssssssssssssss")
              // console.log(this.charts);
              // console.log( this.chartOptions[this.selectedChartIndex]);
              let syncScale=this.chartOptions[this.selectedChartIndex].syncScale;
              this.selectPointsByDrag(e);
              if(this.$parent.$data.isFitting) return;
              //console.log("55555")
              //点击重置按钮  或 框选图表
              if(e.resetSelection != undefined && e.resetSelection == true){
                console.log(e);
                e.target.xAxis[0].update({tickInterval: Math.round(e.target.xAxis[0].userOptions.userCategory.length/10)});

                if (syncScale) {
                  //同步缩放（复原）
                  for (let i = 0; i < this.charts.length; i++) {
                    // this.charts[i].xAxis[0].setExtremes(undefined, undefined);
                    this.charts[i].zoom();//重置图表
                  }
                }
              }
              else {
                console.log(e, e.xAxis[0].min, e.xAxis[0].max);
                let len = e.xAxis[0].max - e.xAxis[0].min;
                let minTicket = Math.floor(len / 10);
                if (Math.floor(e.xAxis[0].min) % minTicket != 0) {
                  for (let newTicket = minTicket - 1; newTicket >= 1; newTicket--) {
                    if (Math.floor(e.xAxis[0].min) % newTicket == 0) {
                      minTicket = Math.floor(e.xAxis[0].min) / newTicket;
                      break;
                    }
                  }
                }
                e.target.xAxis[0].update({tickInterval: minTicket});

                if (syncScale) {
                  //同步缩放（放大）
                  let min = e.xAxis[0].min;
                  let max = e.xAxis[0].max;
                  for (let i = 0; i < this.charts.length; i++) {
                    this.charts[i].xAxis[0].setExtremes(min, max);
                    // this.charts[i].zoomOut();
                  }
                }
              }
            }
          }
        },
        pieClickEvent: {
          events: {
            click: (e) => {
              this.pieClick(e)
            }
          }
        },
        pieSelectDic: {}, //{chartindex: piePointIndex}
        hasAxisOption: true,
        isReloadData: true,
        showChartOption: false,
        chartConfigModifyFlag:false,
        chartContentStyle:{
          "height":"300px",
          "margin-bottom":"1px",
          "margin-left": "28px"
        },//曲线默认绘制样式

        dataBoxSelection:[],//框选数据，暂定
      }
    },
    mounted() {
      // this.reload(); //todo 会执行两次  监听刷新，可注释。
      // document.oncontextmenu = function(){return false};
      // let _this =this;
      // document.addEventListener('contextmenu',function(e){
      //   _this.openMenu(e)
      //  })
      //let _this = this;
      /*document.addEventListener('click',function(e){
        console.log(e.path)
        if( _this.showChartOption == true && e.target.path){
          console.log(111)
          _this.showChartOption=false
        }
      })*/
    },
    created: function () {
      //事件转发处理
      eventbus.on('seriesOptionChange', (msg) => {
        this.chartConfigModifyFlag = true;
        this.seriesOptionChange(msg);
      });

      eventbus.on('legendOptionChange', (msg) => {
        this.chartConfigModifyFlag = true;
        this.legendOptionChange(msg);
      });

      eventbus.on('seriesMarkerOptionChange', (msg) => {
        this.chartConfigModifyFlag = true;
        this.seriesMarkerOptionChange(msg);
      });

      eventbus.on('titleOptionChange', (msg) => {
        this.chartConfigModifyFlag = true;
        this.titleOptionChange(msg);
      });

      eventbus.on('pointOptionChange', (msg) => {
        this.chartConfigModifyFlag = true;
        this.pointOptionChange(msg);
      });

      eventbus.on('xAxisOptionChange', (msg) => {
        this.chartConfigModifyFlag = true;
        this.xAxisOptionChange(msg);
      });

      eventbus.on('yAxisOptionChange', (msg) => {
        if(msg.option.tickInterval != undefined || msg.option.tickAmount != undefined || msg.option.max != undefined || msg.option.min != undefined){
          this._calcYAxisTick(msg.option.tickInterval != undefined);
          this.reflashView();//刷新视图
        }
        else{
          this.chartConfigModifyFlag = true;
          this.yAxisOptionChange(msg);
        }
        // this.reflashView();//刷新视图
      });
    },
    methods: {
      // openMenu(e) {
      //   console.log(e)
      //   var x = e.x;
      //   var y = e.y;
      //
      //   this.top = y;
      //   this.left = x;
      //
      //   this.visibles = true;
      // },
      // closeMenu() {
      //   this.visibles = false;
      // },
      //快捷菜单
      contextmenu(e){
        e.preventDefault();
        var x = e.clientX;
        var y = e.clientY;
        this.contextMenuData.axis = {
          x,
          y
        }
      },
      //获取图表配置修改标志
      getChartConfigModifyFlag(){
        return this.chartConfigModifyFlag;
      },
      //获取图表选项
      getChartOptions(){
        /*var jsons = [{
          "a_dataSource": "",
          "title": {
            "text": "日报曲线",
            "style": {
              "color": "#000000",
              "display": "block"
            }
          },
          "legend": {
            "enabled": true,
            "align": "right",
            "verticalAlign": "top",
            "floating": false
          },
          "xAxis": {
            "title": {
              "text": "时间"
            },
            "a_filed":"",
            "label":"",
            "a_type": "年月"
          },
          "yAxis":[{
            "type":"linear",
            "title":{
              "enabled":true,
              "text":"月产油",
              "style":{
                "color":"#000"
              }
            },
            "series":[{
              "name":"月产油",
              "type":"line",
              "color":"#f00",
              "step":false,
              "stacking":"normal"
            },{
              "name":"月产水",
              "type":"line",
              "color":"#f00",
              "step":false,
              "stacking":null
            }]

          }]
        }];
        console.log(jsons)*/
        let jj=[];
        // console.log("chartOptions:",this.chartOptions);
        //forEach循环;jj获取chartOptions数据，并清空yAxis中series的数据
        this.chartOptions.forEach(item=>{
          let item1 = JSON.parse(JSON.stringify(item));

          jj.push(item1)
        });
        jj.forEach(item=>{
          item.yAxis.forEach(e=>{
            e.series=[];
          })
        });
        //将jj.series中数据填入jj.yAxis.series中
        for(let i=0;i<jj.length;i++){
          jj[i].series.forEach(item=>{
            // console.log(item);
            if(jj[i].yAxis[item.yAxis] != undefined) {
              jj[i].yAxis[item.yAxis].series.push(item);
            }
          })
        }
        return jj
      },
      //图表选项显示
      chartOptionIsShow(){
        /*this.showChartOption=!this.showChartOption;
        if(this.showChartOption){
          this.debug=0
        }else{
          this.debug=1
        }*/
        this.showChartOption=!this.showChartOption;
        /*var view = document.getElementById("chartOption");
        if(view){
          if(!view.contains(e.target)){
            this.showChartOption=!this.showChartOption;
          }
        }*/

      },
      //重新加载
      reload () {
        this.isReloadData = false;            //先关闭，
        this.$nextTick(function () {
          this.isReloadData = true;         //再打开
          this.$nextTick(function () {
            this.createChart();
          });
        });
      },
      //刷新视图
      reflashView() {
        this.chartConfigModifyFlag = false;

        console.log("charts:",this.charts);
        for(let index=this.charts.length-1; index >=0; index--){
          this.charts[index].destroy();
          this.chartOptions.splice(index,1);
          this.charts.splice(index,1);
        }
        Object.assign(this.chartOptions, this.option);

        if(this.chartOptions.length > 0) {
          this.reload();
        }
      },
      //创建图表
      createChart(){
        console.log("createChart start``````````");
        // this.showChartOption = false //设置界面隐藏
        for (let index = 0; index < this.chartOptions.length; index++) {

          this.chartOptions[index].tooltip = {}
          let _this = this;
          this.chartOptions[index].tooltip.formatter = function(){
            let xAxisLabel = _this.chartOptions[index].xAxis.userCategory.length>0?_this.chartOptions[index].xAxis.userCategory[this.x]:this.x;
            let resultStr = "<span style='color:{series.color}'>"+xAxisLabel+"</span><br/> <b>"+this.series.name+"：</b>"+this.y;
            return resultStr;
          }
          this.chartOptions[index].xAxis.labels.formatter
            = function (){
                //userCategory [Array] 存放自定义x的标签数组
            // console.log(this.axis);
            //仅年月模式正确，数值模将来要判断
            // console.log(this.value);
            // return this.value;
            let xAxisLabel = this.axis.userOptions.userCategory.length>0?this.axis.userOptions.userCategory[this.value]:this.value;

            if(this.isLast){
              if(xAxisLabel == undefined) xAxisLabel = this.axis.userOptions.userCategory[this.axis.userOptions.userCategory.length-1]
            }
            else if(xAxisLabel.length == 10){
              if(this.axis.userOptions.userCategory.length-this.value-1 <=Math.floor(this.axis.tickInterval/2)) return "";
            }
            return xAxisLabel;
            }
          // this.chartOptions[index].xAxis.afterSetExtremes = function(e){
          //   console.log('New min:', e.min, 'New max:', e.max);
          // }

          let _id = "chart_" + index;
          this.chartOptions[index].chart.events = this.chartEvent.events;
          let chartStyle = {};//图表全局样式
          chartStyle.fontFamily = '方正大黑简体'
          this.chartOptions[index].chart.style = chartStyle;//全局样式设置（部分不生效）
          this.chartOptions[index].xAxis.labels.style = chartStyle;//x轴字体样式
          this.chartOptions[index].legend.itemStryle = chartStyle;//图例字体样式
          this.chartOptions[index].title.style.fontFamily = chartStyle.fontFamily;//标题字体样式

          for(let iseries = 0; iseries < this.chartOptions[index].series.length; iseries++){
            if(this.chartOptions[index].series[iseries].type == 'pie'){
              this.chartOptions[index].series[iseries]["point"] = this.pieClickEvent;
            }
            if(this.chartOptions[index].series[iseries].type == 'scatter'){
              this.chartOptions[index].series[iseries].lineWidth = 0;
            }
          }
          //chart size
          let chart = HighCharts.chart(_id, this.chartOptions[index]);
          this.charts.push(chart);
          //this.charts.push(HighCharts.chart(_id, this.chartOptions[index]));

          console.log("createChart starting", index, chart);
        }
        console.log("createChart end``````````");
        this.$parent.$data.loading=false;

        if (this.chartOptions.length > 0) {
          this.selectedChartOption = this.chartOptions[this.selectedChartIndex];
          this.selectObjInfo = {
            "selectType": "chart",
            "chartIndex":this.selectedChartIndex,
            "seriesIndex": 0,
            "pointIndex": -1
          };
        }
      },
      //系列选项更改
      seriesOptionChange(param) {
        console.log('seriesOptionChange',param.id);
        let id = param.id;
        let option = param.option;
        if (this.charts.length > 0 && this.charts[this.selectedChartIndex].series.length > 0) {
          let c = 0, len = this.chartOptions.length;
          if (this.chartType == "normal") {
            c = this.selectedChartIndex;
            len = this.selectedChartIndex+1;
          }
          else if (this.selectedChartIndex == 0)
            len = 1;
          else
            c = 1;
          for (c; c < len; c++) {
            //1、update highChart
            let series = this.charts[c].get(id);
            console.log('series：',this.charts,series,c,id);
            if(series == undefined) continue;

            series.update(option);

            //2、update chartoptions
            for (let index = 0; index < this.chartOptions[c].series.length; index++) {
              if (this.chartOptions[c].series[index].id == id) {
                for (let key in option) {
                  //判断是否有子集
                  if (Object.keys(option[key]).length > 0 && option[key].constructor == Object) {
                    for (let childKey in option[key]) {
                      this.chartOptions[c].series[index][key][childKey] = option[key][childKey];
                    }
                  } else {
                    this.chartOptions[c].series[index][key] = option[key];
                  }
                }
              }
            }
            console.log('seriesOptionChange -- end');
          }
        }
      },
      //系列标记选项更改
      seriesMarkerOptionChange(param) {
        console.log('seriesMarkerOptionChange',this.selectedChartIndex);
        let id = param.id;
        let option = param.option;
        if (this.charts.length > 0 && this.charts[this.selectedChartIndex].series.length > 0) {
          let c = 0, len = this.chartOptions.length;
          if (this.chartType == "normal") {
            c = this.selectedChartIndex;
            len = this.selectedChartIndex+1;
          }
          else if (this.selectedChartIndex == 0)
            len = 1;
          else
            c = 1;
          for (c; c < len; c++) {
            //1、update highChart
            let series = this.charts[c].get(id);
            series.update(option);

            //2、update chartoptions
            for (let index = 0; index < this.chartOptions[c].series.length; index++) {
              if (this.chartOptions[c].series[index].id == id) {
                for (let key in option) {
                  if (Object.keys(option[key]).length > 0 && option[key].constructor == Object) {
                    for (let childKey in option[key]) {
                      this.chartOptions[c].series[index][key][childKey] = option[key][childKey];
                    }
                  } else {
                    this.chartOptions[c].series[index][key] = option[key];
                  }
                }
              }
            }
            console.log('seriesMarkerOptionChange -- end');
          }
        }
      },
      //图例选项更改
      legendOptionChange(param) {
        console.log('legendOptionChange');
        let option = param.option;
        if (this.charts.length > 0) {
          let c = 0, len = this.chartOptions.length;
          if (this.chartType == "normal") {
            c = this.selectedChartIndex;
            len = this.selectedChartIndex+1;
          }
          else if (this.selectedChartIndex == 0)
            len = 1;
          else
            c = 1;
          for (c; c < len; c++) {
            //1、update highChart
            this.charts[c].legend.update(option);

            //2、update chartoptions
            for (let key in option) {
              this.chartOptions[c].legend[key] = option[key];
            }
            console.log('legendOptionChange -- end');
          }
        }
      },
      //标题选项更改
      titleOptionChange(param) {
        console.log('titleOptionChange');
        let option = param.option;
        if (this.charts.length > 0) {
          let c = 0, len = this.chartOptions.length;
          if (this.chartType == "normal") {
            c = this.selectedChartIndex;
            len = this.selectedChartIndex+1;
          }
          else if (this.selectedChartIndex == 0)
            len = 1;
          else
            c = 1;
          for (c; c < len; c++) {
            //1、update highChart
            this.charts[c].setTitle(option);

            //2、update chartoptions
            for (let key in option) {
              if (Object.keys(option[key]).length > 0 && option[key].constructor == Object) {
                //title:{text:"",style:{display:"", color:"#000000"}}三级
                for (let childKey in option[key]) {
                  this.chartOptions[c].title[key][childKey] = option[key][childKey];
                }
              } else {
                this.chartOptions[c].title[key] = option[key];
              }
            }
            console.log('titleOptionChange -- end');
          }
        }
      },
      //点选项更改
      pointOptionChange(param) {
        let option = param.option;
        console.log("pointOptionChange", param);
        let seriesId = param.seriesId;
        let pointIndex = param.pointIndex;
        if (this.charts.length > 0) {
          let c = 0, len = this.chartOptions.length;
          if (this.chartType == "normal") {
            c = this.selectedChartIndex;
            len = this.selectedChartIndex+1;
          }
          else if (this.selectedChartIndex == 0)
            len = 1;
          else
            c = 1;
          for (c; c < len; c++) {
            //1、update highChart
            let series = this.charts[c].get(seriesId);
            series.data[pointIndex].update(option);

            //2、update chartoptions
            for (let key in option) {
              if (Object.keys(option[key]).length > 0 && option[key].constructor == Object) {
                //title:{name:"", y:"", color:"#000000"}
                this.chartOptions[this.selectedChartIndex].series[series.index].data[pointIndex][key] = option[key];
              } else {
                this.chartOptions[this.selectedChartIndex].title[key] = option[key];
              }
            }
            console.log('pointOptionChange -- end');
          }
        }
      },
      //x轴选项更改
      xAxisOptionChange(param) {
        console.log('xAxisOptionChange');
        let option = param.option;
        if (this.charts.length > 0) {
          let c = 0, len = this.chartOptions.length;
          if (this.chartType == "normal") {
            c = this.selectedChartIndex;
            len = this.selectedChartIndex+1;
          }
          else if (this.selectedChartIndex == 0)
            len = 1;
          else
            c = 1;
          for (c; c < len; c++) {
            //1、update highChart
            this.charts[c].xAxis[0].update(option);

            //2、update chartoptions
            for (let key in option) {
              if (Object.keys(option[key]).length > 0 && option[key].constructor == Object) {
                for (let childKey in option[key]) {
                  this.chartOptions[c].xAxis[key][childKey] = option[key][childKey];
                }
              } else {
                this.chartOptions[c].xAxis[key] = option[key];
              }
            }
          }
        }
        console.log('xAxisOptionChange -- end');
      },
      //y轴选项更改
      yAxisOptionChange(param) {
        console.log('yAxisOptionChange');
        console.log(param);
        let option = param.option;
        let id = param.yAxisId;
        if (this.charts.length > 0) {
          let c = 0, len = this.chartOptions.length;
          if (this.chartType == "normal") {
            c = this.selectedChartIndex;
            len = this.selectedChartIndex+1;
          }
          else if (this.selectedChartIndex == 0)
            len = 1;
          else
            c = 1;
          for (c; c < len; c++) {
            //1、update highChart
            let yAxis = this.charts[c].get(id);
            yAxis.update(option);

            //2、update chartoptions
            for (let index = 0; index < this.chartOptions[c].yAxis.length; index++) {
              if (this.chartOptions[c].yAxis[index].id == id) {
                for (let key in option) {
                  if (Object.keys(option[key]).length > 0 && option[key].constructor == Object) {
                    for (let childKey in option[key]) {
                      this.chartOptions[c].yAxis[index][key][childKey] = option[key][childKey];
                    }
                  } else {
                    this.chartOptions[c].yAxis[index][key] = option[key];
                  }
                }
              }
            }
            console.log('yAxisOptionChange -- end');
          }
        }
      },
      //点击图表
      chartClick(param) {
        console.log("chartClick");
        if (param.xAxis.length > 0) {
          let clickChart = param.xAxis[0].axis.chart;
          //chart index 在刷新后会变化所以不能按照Chart.index，需要重新定位下标
          for(let index=0; index<this.charts.length; index++){
            if(clickChart.index == this.charts[index].index){
              this.selectedChartIndex = index;
            }
          }
          this.selectedChartOption = this.chartOptions[this.selectedChartIndex];

          this.unselectByClick();
        }

        //this.selectObjType = "chart";
        this.selectObjInfo = {
          "selectType": "chart",
          "chartIndex":this.selectedChartIndex,
          "seriesIndex": 0,
          "pointIndex": -1
        };
      },
      //饼状点击
      pieClick(param) {
        console.log(param);
        //chart index 在刷新后会变化所以不能按照Chart.index，需要重新定位下标
        for(let index=0; index<this.charts.length; index++){
          if(param.point.series.chart.index == this.charts[index].index){
            this.selectedChartIndex = index;
          }
        }

        this.pieSelectDic[this.selectedChartIndex] = param.point.index;
        this.selectedChartOption = this.chartOptions[this.selectedChartIndex];
        this.selectObjInfo = {
          "selectType": "point",
          "chartIndex":this.selectedChartIndex,
          "seriesIndex": param.point.series.index,
          "point": param.point
        };
      },
      //通过拖动选择点
      selectPointsByDrag(param) {
        // console.log(param);
        // console.log(this.charts);
        if(!this.$parent.$data.isFitting) return true;
        console.log("selectPointsByDrag",this.$parent.$data.isFitting);

        this.dataBoxSelection=[]//初始化框选数据

        //chart index 在刷新后会变化所以不能按照Chart.index，需要重新定位下标
        for(let index=0; index<this.charts.length; index++){
          if(param.target.index == this.charts[index].index){
            this.selectedChartIndex = index;
          }
        }

        // console.log("----------");
        // console.log(param);
        // console.log(this.charts);
        // console.log(this.selectedChartIndex);
        // console.log("------------");

        let chart = this.charts[this.selectedChartIndex];

        if(chart.series.length > 1){
          return true;
        }

        // 选中当前范围内的点
        let series = chart.series[0];
        for(let index=0; index < series.points.length; index++){
          let point = series.points[index];
          if (point.x >= param.xAxis[0].min && point.x <= param.xAxis[0].max &&
              point.y >= param.yAxis[0].min && point.y <= param.yAxis[0].max) {
            point.select(true, true);
          }
          point.options.name=this.selectedChartOption.xAxis.userCategory[point.x];
          this.dataBoxSelection.push(point.options)//添加选择数据
        }
        //排除井组曲线
        if (this.$parent.$data.chartType == 'normal' && this.$parent.$data.isFitting) {
          this.$parent.$data.selectedChartIndex = this.selectedChartIndex;//传递 选中的坐标绘图顺序
          this.$parent.$data.dataBoxSelection = JSON.parse(JSON.stringify(this.dataBoxSelection));//将框选数据传给父组件：ChartView
          this.$parent.$data.viewBoxSelection = true;//打开拟合选值展示框
          //延时勾选所有数据
          setTimeout(() => {
            this.$parent.$refs.multipleTableRef.clearSelection();//清空勾选状态
            for (let i = 0; i < this.dataBoxSelection.length; i++) {
              if ('selected' in this.dataBoxSelection[i]) {
                this.$parent.$refs.multipleTableRef.toggleRowSelection(this.$parent.$data.dataBoxSelection[i], true);//切换勾选数据的勾选状态
              }
            }
          }, 100)
        }

        // 触发自定义事件
        //Highcharts.fireEvent(this, 'selectedpoints', { points: this.getSelectedPoints() });

        // false Don't zoom
        console.log("selectPointsByDrag --- end");
        //return false;
        param.preventDefault()
      },
      //单击取消选择
      unselectByClick() {
        console.log("unselectByClick");
        if(this.selectedChartIndex < 0 || this.selectedChartIndex >= this.charts.length){
          return;
        }
        let selectedChart = this.charts[this.selectedChartIndex]
        let points = selectedChart.getSelectedPoints();
        if (points.length > 0) {
          for(let index = 0; index < points.length; index++){
            let point = points[index];
            point.select(false);
          }
        }
      },
      getOptionDivWidthStyle(){
        return "wdith:"+this.optionDivWidth();
      },
      //选项Div宽度
      optionDivWidth(){
        if(this.showChartOption){
          return "250px";
        }
        else{
          return "0px";
        }
      },
      //导出图像
      exportImage(command, fileName){
        if(command =="excel"){
          this.getExcel(fileName)
          return
        }
        console.log(command);
        let svgHeight = 0, svgWidth = 0;
        let downOptions = [];
        this.$parent.$data.loading = true;
        let that = this;
        for(let index=0; index < this.charts.length; index++){
          // this.charts[index].options.chart.width = this.charts[index].chartWidth;
          // this.charts[index].options.chart.height = this.charts[index].chartHeight;
          // for (let y = 0; y < this.charts[index].options.yAxis.length; y++) {
          //   console.log(this.charts[index]);
          //   if (typeof(this.charts[index].options.yAxis[y].title) !== "undefined") {
          //       this.charts[index].options.yAxis[y].title.style.fontSize = "9px";
          //       this.charts[index].options.yAxis[y].title.y = 5;
          //   }
          // }
          let copy = {};
          this.chartOptions[index].chart.width = this.charts[index].chartWidth;
          this.chartOptions[index].chart.height = this.charts[index].chartHeight;
          //Object.assign(copy, this.chartOptions[index]);
          copy["svg"] = this.charts[index].getSVG(this.chartOptions[index]);//加上option获取正确尺寸
          copy["x"] = 0;
          copy["y"] = svgHeight;
          downOptions.push(copy);
          svgHeight += this.charts[index].chartHeight;
          svgWidth = this.charts[index].chartWidth;
        }
        //let fileName = "chart";
        let imagetype = command;
        let params = {"svgWidth":svgWidth, "svgHeight":svgHeight, "filename":fileName, "imagetype":imagetype, "op":[]};
        params["op"] = downOptions;
        console.log("导出", params);
        axios({
          url: process.env.VUE_APP_SERVER + "/fileprocesser/chartFile",
          method:"POST",
          headers: { "Content-Type": "application/json"},
          data: params,
          responseType: 'blob'
        }).then((res)=>{
          console.log(res)
          if(res.status == 200)
          {
            const content = res.data
            const blob = new Blob([content])
            const imageName = fileName + "." + imagetype;
            if ('download' in document.createElement('a')) { // 非IE下载
              const elink = document.createElement('a')
              elink.download = imageName
              elink.style.display = 'none'
              elink.href = URL.createObjectURL(blob)
              document.body.appendChild(elink)
              elink.click()
              URL.revokeObjectURL(elink.href) // 释放URL 对象
              document.body.removeChild(elink)
            } else { // IE10+下载
              navigator.msSaveBlob(blob, imageName)
            }
            that.$parent.$data.loading = false;
          }
          else{
            ElMessage.error('下载文件失败');
            that.$parent.$data.loading = false;
          }

        }).catch((err)=>{
          ElMessage.error('下载文件失败');
          that.$parent.$data.loading = false;
          console.log(err);
        });
      },
      //导出为excel
      getExcel(name){
        let data = {
          curveDatas:[],
          type: "curve",
          fileName: name
        }
        console.log(this.chartOptions)
        this.chartOptions.forEach(item=>{
          let obj = {
            headline: item.title.text,
            // type:"BAR",
            state:"3",
            'x-name':item.xAxis['a_type'],
            "x-axis":item.xAxis.userCategory,
            show_y_left:true,
            show_y_right:true,
            y_left:[],
            y_right:[]
          }
          if(item.title.text.split(']')[1] === "请输入标题"){
            obj.headline = item.title.text.split('请')[0]
          }
          if(item.title.style.display != 'block'){
            obj.headline = ""
          }
          // console.log(item.series[0].type)
          // if(item.series[0].stacking){
          //   obj.state = "1"
          // }
          // if(item.series[0].type == "line") {
          //   obj.type = "LINE"
          // }else if(item.series[0].type == "column"){
          //   obj.type = "BAR"
          // }else if(item.series[0].type == "area"){
          //   obj.type = "AREA"
          // }else if(item.series[0].type == "pie"){
          //   obj.type = "PIE"
          // }else if(item.series[0].type == "scatter"){
          //   obj.type = "SCATTER"
          // }
          item.series.forEach(code=>{
            let color =  code.color
            if(color.length === 4){
                let colorNew = "#";
                for (var i = 1; i < 4; i += 1) {
                  colorNew += color.slice(i, i + 1).concat(color.slice(i, i + 1));
                }
              color = colorNew;
            }

            let colorA = '0x' + color.slice(1, 3);
            let colorB = '0x' + color.slice(3, 5);
            let colorC = '0x' + color.slice(5, 7);
            if(color.indexOf("rgb")>=0){
              let clrList = color.replace("(","").replace(")","").replace("rgba","").replace("rgb","").split(",");
              colorA =clrList[0];
              colorB =clrList[1];
              colorC =clrList[2];
            }

            let lines ={
              'y-name':code.name,
              'type':"BAR",
              'stacking':code.stacking,
              'y-axis':[],
              "rgb_a":parseInt(colorA),
              "rgb_b":parseInt(colorB),
              "rgb_c":parseInt(colorC),
            }

            if(code.type == "line") {
              lines.type = "LINE"
            }else if(code.type == "column"){
              lines.type = "BAR"
            }else if(code.type == "area"){
              lines.type = "AREA"
            }else if(code.type == "pie"){
              lines.type = "PIE"
            }else if(code.type == "scatter"){
              lines.type = "SCATTER"//暂不支持散点
            }

            code.data.forEach(index=>{
              console.log(index.y,index)
              if(index.y != undefined) {
                lines['y-axis'].push(index.y.toString())
              }
              else{
                lines['y-axis'].push("0")
              }
            })
            //Math.max(...lines['y-axis'])
            if(code.yAxis == 0) {
              obj.y_left.push(lines)
            }
            else{
              obj.y_right.push(lines)
            }
          })
          data.curveDatas.push(obj)
        })
        console.log(data)

        let url = `${process.env.VUE_APP_SERVER}/fileprocesser/export/curve`
        axios.post(url,data,{responseType: 'arraybuffer'})
          .then(res=>{
            let blob = new Blob([res.data], { type: 'application/vnd.ms-excel' });
            let url = window.URL || window.webkitURL || window.moxURL;
            let downloadHref = url.createObjectURL(blob);
            let downloadLink = document.createElement('a');
            downloadLink.target = '_blank';
            downloadLink.href = downloadHref;
            downloadLink.download = name + '.xls';
            downloadLink.click();
          })
      },
      //曲线的同步缩放按钮修改触发
      _changeSyncScale(value){
        console.log("同步缩放：",value);
        //同步其他图表的同步缩放标识
        this.option.forEach(item => {
          item.syncScale = value;
        })
      },
      //曲线的同步缩放按钮修改触发
      _changexAisxTick(xAxis){
        console.log("x轴标签修改：",xAxis);
        let minNumber = xAxis.minNumber;
        let tickIntervalNumber = xAxis.tickIntervalNumber;
        let tickAmountNumber = xAxis.tickAmountNumber;
        let positions = [];
        for (let i = 0; i <= tickAmountNumber; i++) {
          positions.push(Number((minNumber + tickIntervalNumber * i).toFixed(2)));
        }
        console.log(positions);
        xAxis.tickPositions = positions;//刻度数组
        this.reflashView();//刷新视图
      },

      //自动计算图表高度
      chartHeightCount(){
        if(this.option.length>0) {//没有曲线不做计算
          let docHeight = document.body.clientHeight - this.headerDefHeight;//曲线页面高度
          // docHeight = Math.max(docHeight,document.getElementsByClassName("main_div")[0].clientHeight);

          //获取所有带标题chart的总高度
          let titleFullHeight = 0;
          for (let index = 0; index < this.option.length; index++) {
            if (this.option[index].title.style.display != "none") {
              titleFullHeight+=this.chartTitleHeight;
            }
          }

          //除掉title高度，计算每个曲线的最小高度

          let oneChartHeight = (docHeight-titleFullHeight) / this.option.length;
          let defOneChartHeight = oneChartHeight+titleFullHeight;
          //如果计算结果小于允许的最小高度则以最小高度为准
          if(defOneChartHeight<this.chartMinHeight) defOneChartHeight = this.chartMinHeight;
          let onechartHeightWithTitle = oneChartHeight+this.chartTitleHeight;
          console.log("thisChartHeightAry",docHeight,titleFullHeight,onechartHeightWithTitle,oneChartHeight)
          if(oneChartHeight<this.chartMinHeight) {
            oneChartHeight = this.chartMinHeight ;
            onechartHeightWithTitle = this.chartMinHeight ;
          }

          //设置每个chart的高度
          this.chartStyle =  defOneChartHeight+"px";
          this.chartHeightAry = [];
          for (let index = 0; index < this.option.length; index++) {
            if (this.option[index].title.style.display != "none") {
              if(this.$parent.$data.isFitting){
                this.chartHeightAry.push("400px")//曲线拟合暂时固定高度
              }
              else{
                if(this.isHomePage == "home"){
                  this.chartHeightAry.push("200px")
                }
                else{
                  this.chartHeightAry.push(onechartHeightWithTitle+"px")
                }
              }
            }
            else{
              if(this.$parent.$data.isFitting){
                this.chartHeightAry.push("400px")//曲线拟合暂时固定高度
              }
              else {
                if(this.isHomePage == "home"){
                  this.chartHeightAry.push("200px")
                }
                else {
                  this.chartHeightAry.push(oneChartHeight + "px")
                }
              }
            }
          }
          console.log("thisChartHeightAry",this.chartHeightAry,this.isHomePage,onechartHeightWithTitle,oneChartHeight)
        }
      },
      //高度自动计算按钮修改触发
      _changeChartStyle(value){
        console.log("自动计算高度：",value);
        //同步其他图表的自动计算标识
        this.option.forEach(item => {
          item.autoChartStyle = value;
        })
        if (value){
          this.chartHeightCount();
          //如果自动计算高度列表与曲线长度不一致，则使用默认高度，否则将chartHeightAry里的高度对应替换到曲线配置里
          if (this.option.length!=this.chartHeightAry.length){
            this.option.forEach(item=>{
              item.chartContentStyle.height=this.chartStyle;
            });
          }
          else {
            this.option.forEach((item,idx)=>{
              item.chartContentStyle.height=this.chartHeightAry[idx];
            });
          }
        }
        this._changeChartYAxis();
      },

      _calcYAxisTick(isInterval) {
        console.log("oooo",this.option)
        let ooption = Array.from(this.option);
        ooption.forEach(chart => {
          //根据图表下对应曲线的最大最小值设置刻度信息
          chart.yAxis.forEach((item) => {
            //自定义刻度相关参数
            let tickMax = item.max;
            let tickmin = item.min;
              //判断y轴类型，linear：常规，计算；对数：logarithmic，不计算
            if (item.type == "linear") {
              let tickAmount=item.tickAmount!=undefined ? (item.tickAmount<4?4:item.tickAmount) : 4;//刻度总数
              let divisor = tickAmount - 1;
              let positions = [];
              let tick = tickmin;
              //计算差值
              let interval = tickMax - tickmin;//差值（间隔）
              let increment = Number((interval / divisor).toFixed(2));//默认改变的不是间隔
              if(isInterval){//如果当前变更的是间隔则改变个数
                increment = item.tickInterval;
                tickAmount = Math.ceil(interval/increment) + (interval % increment != 0 ? 0 : 1);
                item.tickAmount = tickAmount;
              }
              else {//如果当前变更的不是间隔则改变间隔
                //判定刻度个数设置是否合理（余0）
                item.tickInterval = increment;
              }
              console.log(increment);
              if(increment != 0){
                for (tick; tick < tickMax && positions.length < tickAmount; tick += increment) {
                  if(tick != undefined) positions.push(Number(tick.toFixed(2)));
                }
              }
              if(tickMax != undefined) positions.push(Number(tickMax.toFixed(2)));
              console.log(positions);
              // item.tickNumber = tickNumber;//刻度个数
              item.tickPositions=positions;//刻度数组
            }
          })
        })
        // this.reflashView();//刷新视图
      },
      //自动计算y轴标签刻度及y轴左右边距
      _changeChartYAxis() {
        console.log("自动计算刻度，边距");
        this._changeSeriesInterval();
        let marginLeft = 20;//曲线绘制左边距
        let marginRight = 20;//曲线绘制右边距
        let yAxisLeft = [];//左y轴最大位数集合
        let yAxisRight = [];//右y轴最位数集合

        this.option.forEach(chart => {
          let maxObj = {};
          let minObj = {};
          //计算每个图表下每条曲线的最大，最小值
          chart.series.forEach(item => {
            if (item.yAxis != undefined && item.data.length != 0) {
              if (!(item.yAxis.toString() in maxObj))
                maxObj[item.yAxis.toString()] = item.data[0].y;
              if (!(item.yAxis.toString() in minObj))
                minObj[item.yAxis.toString()] = item.data[0].y;
              let max = maxObj[item.yAxis.toString()];
              let min = minObj[item.yAxis.toString()];
              item.data.forEach(ite => {
                //比较最大，最小值
                if (ite.y > max)
                  max = ite.y
                if (ite.y < min)
                  min = ite.y
              })
              maxObj[item.yAxis.toString()] = max;
              minObj[item.yAxis.toString()] = min;
            }

            item.animation=false ;//大
            item.turboThreshold=0;//不限
          })
          console.log("最大值,最小值：", maxObj,minObj);

          let yLeftNum = 0;//左y轴数量
          let yRightNum = 0;//右y轴数量
          //根据图表下对应曲线的最大最小值设置刻度信息
          chart.yAxis.forEach((item, idx) => {
            //自定义刻度相关参数
            let customTick = item.customTick != undefined ? item.customTick : false;
            let tickNumber = item.tickNumber != undefined ? item.tickNumber : 4;
            let tickMax = item.tickMax != undefined ? item.tickMax : item.max;
            let tickmin = item.tickmin != undefined ? item.tickmin : item.min;
            item.customTick = customTick;//固定刻度
            // item.tickNumber = tickNumber;//刻度个数
            item.tickMax = tickMax;//最大值
            item.tickmin = tickmin;//最小值
            console.log("min,max",tickmin,tickMax)
            if (item.customTick){
              console.log("固定刻度:",item);
              let positions = [];
              let tick = tickmin;
              //计算差值，如果刻度个数大于最大值（小数），则差值*100
              let interval=tickNumber > tickMax ? (tickMax - tickmin) * 100 : tickMax - tickmin;//差值（间隔）
              //判定刻度个数设置是否合理（余0）
              while (interval % tickNumber != 0 && tickNumber > 2) {
                tickNumber--;
              }

              let increment = (tickMax - tickmin) / tickNumber;
              for (tick; tick <= tickMax && positions.length <= tickNumber; tick += increment) {
                positions.push(Number(tick.toFixed(2)));
              }
              console.log(increment);
              console.log(positions);
              item.tickNumber = tickNumber;//刻度个数
              item.tickPositions=positions;//刻度数组
              // item.tickPixelInterval=15;
              // item.tickInterval=0;
            }
            else {
              //判断y轴类型，linear：常规，计算；对数：logarithmic，不计算
              if (item.type == "linear") {
                let tickAmount=item.tickAmount!=undefined ? (item.tickAmount<4?4:item.tickAmount) : 4;//刻度总数
                // let divisor = tickAmount-1;
                if(minObj[idx.toString()] != null  && maxObj[idx.toString()] != null) {
                  tickmin = Number(minObj[idx.toString()].toFixed(2));
                  tickMax = Number(maxObj[idx.toString()].toFixed(2));
                  // let step = tickMax - tickmin;
                  // if (step > 2) {//取整
                  //   item.tickInterval = Math.ceil(step / divisor);//刻度间隔
                  // } else {//取四位小数
                  //   item.tickInterval = Number((step / divisor).toFixed(2));
                  // }
                  // item.min = tickmin;
                  // item.max = item.min + item.tickInterval * divisor;

                  let positions = [];
                  let tick = tickmin;
                  //计算差值，如果刻度个数大于最大值（小数），则差值*100
                  let interval= tickMax - tickmin;//差值（间隔）
                  //判定刻度个数设置是否合理（余0）
                  let divisor = tickAmount - 1;
                  let increment = Number((interval / divisor).toFixed(2));
                  // tickMax = tickmin+increment*divisor;
                  // while (interval % tickAmount != 0 && tickAmount > 2) {
                  //   tickAmount--;
                  // }
                  //
                  // let increment = (tickMax - tickmin) / tickAmount;
                  item.tickInterval = increment;
                  item.min = tickmin;
                  item.max = tickMax;
                  item.tickAmount = tickAmount;
                  // item.tickAmount = tickAmount-1;
                  if(increment != 0){
                    for (tick; tick < tickMax && positions.length < tickAmount; tick += increment) {
                      if(tick != undefined) positions.push(Number(tick.toFixed(2)));
                    }
                  }
                  if(tickMax != undefined) positions.push(Number(tickMax.toFixed(2)));
                  // console.log(increment);
                  // console.log(positions);
                  // item.tickNumber = tickNumber;//刻度个数
                  item.tickPositions=positions;//刻度数组
                }
              }
              if (item.type == "logarithmic") {
                delete item.tickPositions;
                item.min = 0.1;
                item.max = 10000;
                item.tickInterval = 1;//刻度间隔
                item.minorTickInterval = 0.1;//最小刻度间隔
              }

            }

            //计算y轴曲线标签的最大位数
            let len = maxObj[item.index==undefined?idx.toString():item.index.toString()]!=null ? maxObj[item.index==undefined?idx.toString():item.index.toString()].toString().length : 0;//获取对应曲线最大值的数字位数
            //判断y轴位置
            if ('opposite' in item && item.opposite == true) {
              if (item.visible && yAxisRight.length >= yRightNum && (yAxisRight[yRightNum] == undefined || yAxisRight[yRightNum] < len))
                yAxisRight[yRightNum] = len;
              yRightNum++;
            }
            else {
              if (item.visible && yAxisLeft.length >= yLeftNum && (yAxisLeft[yLeftNum] == undefined || yAxisLeft[yLeftNum] < len))
                yAxisLeft[yLeftNum] = len;
              yLeftNum++;
            }
          })


          //x轴参数配置
          if (chart.xAxis.xAxisType == "数值") {
            //初始化自动计算x轴标签
            console.log("数值x轴：", chart.xAxis);
            //x轴对向显示，则设置刻度线向内：inside  ，向外：outside
            if (chart.xAxis.opposite)
              chart.xAxis.tickPosition = 'inside'
            let xMinData = 0.0;
            let xMaxData = 0.0;
            chart.series.forEach((item, idx) => {
              if (idx == 0) {
                xMinData = item.xMinData;
                xMaxData = item.xMaxData;
              }
              else if (item.xMinData < xMinData)
                xMinData = item.xMinData;
              else if (item.xMaxData > xMaxData)
                xMaxData = item.xMaxData;
            })
            console.log("最小，最大值：", xMinData, xMaxData);
            if (xMinData!=0 && xMaxData!=0){
              let tickInterval,min;
              let step=xMaxData-xMinData;
              if (step <= 1) {
                tickInterval = 0.1;
                min = xMinData - 0.1;
              }
              else if (step <= 10) {
                tickInterval = 1;
                min = Math.floor(xMinData / 10) * 10;
              }
              else if (step <= 50) {
                tickInterval = 5;
                min = Math.floor(xMinData / 10) * 10;
              }
              else if (step <= 100) {
                tickInterval = 10;
                min = Math.floor(xMinData / 10) * 10;
              }
              else if (step <= 200) {
                tickInterval = 20;
                min = Math.floor(xMinData / 10) * 10;
              }
              else if (step <= 500) {
                tickInterval = 50;
                min = Math.floor(xMinData / 10) * 10;
              }
              else if (step <= 1000) {
                tickInterval = 100;
                min = Math.floor(xMinData / 100) * 100;
              }
              else {
                tickInterval = 1000;
                min = Math.floor(xMinData / 1000) * 1000;
              }
              chart.xAxis.minNumber = min;
              chart.xAxis.tickIntervalNumber = tickInterval;
            }

            //默认赋值x轴的最小值，标签间隔，标签个数
            if (chart.xAxis.minNumber == undefined)
              chart.xAxis.minNumber = 0;
            if (chart.xAxis.tickIntervalNumber == undefined)
              chart.xAxis.tickIntervalNumber = 10;
            if (chart.xAxis.tickAmountNumber == undefined)
              chart.xAxis.tickAmountNumber = 10;
            let minNumber = chart.xAxis.minNumber;
            let tickIntervalNumber = chart.xAxis.tickIntervalNumber;
            let tickAmountNumber = chart.xAxis.tickAmountNumber;
            let positions = [];
            for (let i = 0; i <= tickAmountNumber; i++) {
              positions.push(Number((minNumber + tickIntervalNumber * i).toFixed(2)));
            }
            console.log(positions);
            chart.xAxis.tickPositions = positions;//刻度数组
          }
          else {
            // let tickAmount=chart.xAxis.tickAmount!=undefined ? item.tickAmount : 10;
            chart.xAxis.tickInterval=Math.round(chart.xAxis.userCategory.length/10);
            chart.xAxis.endOnTick=true;
            if(!this.$parent.$data.isFitting){
              console.log("mynoFitChart",chart);
            }
            if(chart.xAxis.userCategory.length>0) {
              chart.xAxis.max = chart.xAxis.userCategory.length - 1;
              chart.xAxis.tickPositioner = function () {
                const axis = this
                return axis.tickPositions.map((pos) => {
                  // console.log("pos",pos);
                  if(pos-Math.floor(pos)!=0) pos = Math.floor(pos);//仅年月模式x轴正常，数值要修改此处
                  if (pos <= axis.max) return pos // If between range
                  else if (pos > axis.max) return axis.max
                })
              };
            }
          }
        })

        //计算y轴左右边距
        yAxisLeft.forEach(item => {
          marginLeft += item >= 4 ? 80 : 50;
        })
        yAxisRight.forEach(item => {
          marginRight += item >= 4 ? 80 : 50;
        })
        // console.log("skhshksjsbjsbsj:",marginLeft,marginRight)
        // console.log("skhshksjsbjsbsj:",yAxisLeft,yAxisRight)
        this.option.forEach(chart => {
          if(chart.legend.align != "center")
          chart.legend.x = (chart.legend.align=="right"?marginRight*-1:marginLeft);
          chart.chart.marginLeft = marginLeft;
          chart.chart.marginRight = marginRight;

          //判断是否存在 特定网格标识
          if (chart.xAxis.isGridLineSpecial == undefined) {
            chart.xAxis.isGridLineSpecial = false;//默认 不启用
          }
          if (chart.xAxis.gridLineColor == undefined || chart.xAxis.gridLineColor == "undefined") {
            chart.xAxis.gridLineColor = "#000";//网格线颜色
            chart.xAxis.gridLineColorSpecial = "#000";//网格线颜色
          }
          if (chart.xAxis.gridLineDashStyle == undefined || chart.xAxis.gridLineDashStyle == "undefined") {
            chart.xAxis.gridLineDashStyle = "Solid";//网格线类型
            chart.xAxis.gridLineDashStyleSpecial = "Solid";//网格线类型
          }
          //启用 特定网格 todo 目前只支持年月类型
          if (chart.xAxis.isGridLineSpecial == true && chart.xAxis.a_type == "年月") {
            let width = chart.xAxis.gridLineWidthSpecial != undefined ? chart.xAxis.gridLineWidthSpecial : chart.xAxis.gridLineWidth != 0 ? chart.xAxis.gridLineWidth : 1;
            chart.xAxis.gridLineWidthSpecial = width;
            chart.xAxis.gridLineWidth = 0;
            chart.xAxis.gridLineColorSpecial = chart.xAxis.gridLineColorSpecial != undefined ? chart.xAxis.gridLineColorSpecial : chart.xAxis.gridLineColor;
            chart.xAxis.gridLineDashStyleSpecial = chart.xAxis.gridLineDashStyleSpecial != undefined ? chart.xAxis.gridLineDashStyleSpecial : chart.xAxis.gridLineDashStyle;
            let userCategory = chart.xAxis.userCategory;
            let plotLines = [];
            // let seriesData=chart.series[0].data;
            for (let i = 0; i < userCategory.length; i++) {
              //x轴特定位置花网格 （每年的12月份）
              if (userCategory[i].substring(4, 6) == "12") {
                let plotLineChlid = {
                  type:"line",
                  zIndex:1000,//层叠
                  dashStyle: chart.xAxis.gridLineDashStyleSpecial,//样式
                  color: chart.xAxis.gridLineColorSpecial,//颜色
                  width: width,//宽度
                  value: i,//x轴位置（数值）
                  // value: function(i, seriesData) {
                  //   // 假设你想让线的结束位置对应到 y 轴的 50 值
                  //   return seriesData[i].y;
                  // }
                }
                plotLines.push(plotLineChlid);
              }
            }
            chart.xAxis.plotLines = plotLines;
          }
          //关闭 特定网格 todo 目前只支持年月类型
          if (chart.xAxis.isGridLineSpecial == false && chart.xAxis.a_type == "年月") {
            chart.xAxis.gridLineWidth = 0;
            chart.xAxis.gridLineColor = chart.xAxis.gridLineColorSpecial;
            chart.xAxis.gridLineDashStyle = chart.xAxis.gridLineDashStyleSpecial;
            delete chart.xAxis.plotLines;
          }
        })



        this.reflashView();//刷新视图
      },
      //计算曲线标签，点间隔
      _changeSeriesInterval() {
        //解决井组曲线的 标签间隔，点间隔不同步的问题
        if (this.chartType == "wellgroup" && this.selectedChartIndex!=0){
          let selectChart = this.option[this.selectedChartIndex];
          this.option.forEach((chart,idx) => {
            if (idx!=0 && idx!=this.selectedChartIndex){
              chart.series.forEach((item,idenx) => {
                item.dataLabelsInterval = selectChart.series[idenx].dataLabelsInterval;
                item.markerInterval = selectChart.series[idenx].markerInterval;
              })
            }
          })
        }
        //计算曲线 标签，点 间隔，断点显示
        this.option.forEach(chart => {
          chart.series.forEach(item => {
            let dataArr = [];//数据列表
            if (item.dataLabelsInterval==undefined || item.dataLabelsInterval==null)
              item.dataLabelsInterval=1;//标签间隔标识 默认赋值
            if (item.markerInterval==undefined || item.markerInterval==null)
              item.markerInterval=1;//点间隔标识 默认赋值
            if (item.breakPointShow == undefined || item.breakPointShow == null) {
              item.breakPointShow = true;//显示断点标识 默认显示
              //散点图  拟合曲线  预测曲线
            }
            if (item.type == 'scatter' || item.name.indexOf("拟合")!=-1 || item.name.indexOf("预测")!=-1)
              item.breakPointShow = false;//显示断点标识 默认不显示
            item.data.forEach((ite, idx) => {
              //替换数据格式，控制曲线标签，点的显示间隔
              let dataObj = {
                dataLabels: {
                  enabled: (item.dataLabels.enabled && idx % item.dataLabelsInterval == 0) ? true : false
                },
                marker: {
                  //散点图默认显示所有点
                  enabled: (item.type == 'scatter' || (item.marker.enabled && idx % item.markerInterval == 0)) ? true : false,
                  symbol : item.marker.symbol
                },
                x: ite.x != undefined ? ite.x : idx
              };
              dataObj.y = ite[1] == undefined ? ite.y : ite[1];
              if (dataObj.y == undefined)
                dataObj.y = null;
              //断点不显示
              if (!item.breakPointShow && (dataObj.y == 0 || dataObj.y == "0"))
                dataObj.y = null;
              //断点显示
              if(item.breakPointShow && dataObj.y == null)
                dataObj.y = 0;
              dataArr.push(dataObj);
            })
            item.data = dataArr;
            // console.log("dataArr:",dataArr);
          })

          //series与yAxis.series的配置不同步，进行同步操作
          chart.yAxis.forEach(yAxis=>{
            if (yAxis.series != undefined && chart.series != undefined) {
              yAxis.series.forEach(item => {
                chart.series.forEach(ite => {
                  if (item.id == ite.id) {
                    item.dataLabelsInterval = ite.dataLabelsInterval;
                    item.markerInterval = ite.markerInterval;
                    item.dataLabels = ite.dataLabels;
                    item.marker = ite.marker;
                    item.data = ite.data;
                  }
                })
              })
            }
          })
        })
      }
    }
  }
</script>
<style>
.div-opacity{ background:#000;width:200px;height:100px;padding:5px;color:#F00;
  filter:alpha(Opacity=60);-moz-opacity:0.6;opacity: 0.6}
.main_div {
  position: absolute;
  right: 30px;
  width: 100%;
}
.float_div{
  position: absolute;
  right: 5px;
  top: 60px;
  filter:alpha(Opacity=100);-moz-opacity:1.0;opacity: 1.0;
}
.option{
    height: 700px;
    overflow: auto;
}
.affix-container{
  z-index: 99;
}
</style>